export default "__VITE_ASSET__B6LEqU$O__"